module.exports = __webpack_public_path__ + "media/images/vp/bg.rightcol-1c5e67ae95be7107053609f36cc0e6af.png";